import fetchMerchandiseSearchFacets from 'actions/merchandise/fetchMerchandiseSearchFacets'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import getObjectKey from 'lib/object/getObjectKey'
import { EmptyObject } from 'lib/object/objectUtils'
import { useEffect } from 'react'

type ReturnType = [
  facets: Array<App.MerchandiseAnySearchFacet>,
  fetching: boolean,
  error: any
]

interface Options {
  disabled?: boolean
}

function useMerchandiseSearchFacets(
  filters: App.MerchandiseFilters = EmptyObject,
  options: Options = EmptyObject,
): ReturnType {
  const key = getObjectKey(filters)

  const facets = useAppSelector(state => state.merchandise.merchandiseSearchFacets[key])
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!options.disabled) {
      dispatch(fetchMerchandiseSearchFacets(filters))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, options.disabled])

  return [
    facets?.facets ?? EmptyArray,
    facets?.fetching ?? !facets?.facets,
    facets?.error,
  ]
}

export default useMerchandiseSearchFacets
